var exports = {
  "qW": "ShopCountdown.module__countdown___ZGJzWG",
  "r3": "ShopCountdown.module__dialog___ZGJzWG",
  "$e": "ShopCountdown.module__warning___ZGJzWG",
  "Kk": "ShopCountdown.module__icon___ZGJzWG",
  "kB": "ShopCountdown.module__time___ZGJzWG",
};

module.exports = exports;
